import { render, staticRenderFns } from "./charging-statistics.vue?vue&type=template&id=0bed1afa&scoped=true&"
import script from "./charging-statistics.vue?vue&type=script&lang=js&"
export * from "./charging-statistics.vue?vue&type=script&lang=js&"
import style0 from "./charging-statistics.vue?vue&type=style&index=0&id=0bed1afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bed1afa",
  null
  
)

export default component.exports